module.exports = __webpack_public_path__ + "img/logo-15.1defc8a.jpg";